module.exports = __webpack_public_path__ + "img/ins-copy.f82287ba.svg";